import React from 'react'
import CreateUserDepartment from '../../components/userdepartmentcomponents/CreateUserDepartment'

function UserDepartmentRegister({renderPageContent}) {
    return (
        <>
                        <CreateUserDepartment renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}
export default UserDepartmentRegister
